const MONTAGE_HANDLE = 'montage';

// Versteckte Lieferart-Property für die Montage-Zeile. Das Montageprodukt hat
// selbst kein custom.lieferart-Metafeld; der Wert wird daher fix gesetzt, damit
// die Montage – wie jedes andere Produkt – ihre Lieferart in die Bestellung trägt.
const MONTAGE_LIEFERART = 'BML (mit Montage)';

// Sichtbare Property (ohne Unterstrich → rendert Shopify im Checkout/Order unter
// der Montagezeile). Ersetzt für Montagebestellungen die konkrete Lieferzeit-
// Anzeige: der Termin wird telefonisch geklärt. Muss mit dem Text in
// snippets/cart-summary.liquid (Cart-Box) übereinstimmen.
const MONTAGE_LIEFERTERMIN_KEY = 'Liefertermin';
const MONTAGE_LIEFERTERMIN_TEXT = 'Wir melden uns 1 bis 2 Arbeitstage nach deiner Bestellung telefonisch bei dir und klären alle notwendigen Informationen und den möglichen Liefer- und Montagetermin.';

// Serialisierung: Es läuft immer höchstens ein Sync. Cart-Events, die während
// eines laufenden Syncs eintreffen, setzen nur syncAusstehend — nach dem Lauf
// wird einmal mit frischem Cart-Stand nachgezogen. So geht bei schnellen
// +/−-Klicks nie der letzte Stand verloren und es entstehen keine parallelen
// Läufe (= keine doppelten Montage-Zeilen).
let syncLaeuft = false;
let syncAusstehend = false;

function getCartSectionId() {
  return document.querySelector('cart-items-component')?.dataset.sectionId;
}

function dispatchMontageCartUpdate(data) {
  document.dispatchEvent(new CustomEvent('cart:update', {
    bubbles: true,
    detail: {
      resource: data,
      sourceId: null,
      data: {
        sections: data.sections,
        source: 'cart-montage'
      }
    }
  }));
}

// Ziel-Variante + Menge für eine Brutto-Montagesumme (in Cent).
// Die Staffel deckt nur bis zur höchsten Variante (aktuell 1000 €, 100-Varianten-
// Limit von Shopify). Summen darüber werden auf Menge × Variante verteilt,
// pro Einheit auf die nächsthöhere Staffelstufe aufgerundet.
function findeMontageZiel(summeInCent, varianten) {
  const preise = varianten.map(v => v.price).sort((a, b) => a - b);
  const maxPreis = preise[preise.length - 1];

  let menge = 1;
  let zielPreis = summeInCent;
  if (summeInCent > maxPreis) {
    menge = Math.ceil(summeInCent / maxPreis);
    zielPreis = Math.ceil(summeInCent / menge);
  }

  const passenderPreis = preise.find(p => p >= zielPreis);
  if (passenderPreis === undefined) return null;

  return {
    variante: varianten.find(v => v.price === passenderPreis),
    menge,
  };
}

// Netto-Montagepreis je Einheit einer Zeile. Einzelprodukte tragen ihn als
// _montage_preis (vom PDP-Formular aus dem Varianten-Metafeld). Bundle-Zeilen
// (has_components) haben das Metafeld nicht und /cart.js liefert ihre Komponenten
// nicht – cart-products.liquid rechnet den Preis aus den Komponenten und rendert
// ihn als data-hali-montage-preis auf die Zeile (die Section ist zu diesem Zeitpunkt
// bereits neu gemorpht, weil erst /cart.js abgewartet wird). hali-liefertermin-sync.js
// schreibt den Wert zusätzlich als Property nach, daher der Fallback.
function montagePreisProEinheit(item) {
  if (item.has_components) {
    const row = document.querySelector(`.cart-items__table-row[data-key="${item.key}"]`);
    const fresh = row?.dataset.haliMontagePreis;
    if (fresh !== undefined && fresh !== '') return parseFloat(fresh) || 0;
  }
  return parseFloat(item.properties?._montage_preis || 0);
}

async function syncMontage() {
  if (syncLaeuft) {
    syncAusstehend = true;
    return;
  }
  syncLaeuft = true;
  try {
    do {
      syncAusstehend = false;
      await syncMontageEinmal();
    } while (syncAusstehend);
  } finally {
    syncLaeuft = false;
  }
}

async function syncMontageEinmal() {
  const cart = await fetch('/cart.js').then(r => r.json());

  const montageItems = cart.items.filter(i => i.handle === MONTAGE_HANDLE);
  if (montageItems.length === 0) return;

  let montageSumme = 0;
  cart.items.forEach(item => {
    if (item.handle === MONTAGE_HANDLE) return;
    montageSumme += montagePreisProEinheit(item) * item.quantity;
  });

  // Alle Änderungen in EINEM /cart/update.js-Request (atomar): alte
  // Montage-Zeilen auf 0, Ziel auf Menge. Kein change→0 + add mehr, dessen
  // Zwischenzustand bei parallelen Events doppelte Zeilen erzeugt hat.
  const updates = {};

  if (montageSumme === 0) {
    // Kein Produkt mit Montagepreis mehr im Warenkorb → Montage entfernen
    montageItems.forEach(i => { updates[i.key] = 0; });
  } else {
    // _montage_preis ist netto, Montage-Variant-Preise (cart.js) sind brutto →
    // mit dem in theme.liquid gerenderten Tax-Divisor (DE 119, sonst 120) auf
    // brutto skalieren, sonst greift bei AT 2× s32 statt €120 die €108-Variante.
    const taxDivisor = window.HALI_TAX_DIVISOR || 120;
    const montageSummeInCent = Math.round(montageSumme * taxDivisor);

    const montageProdukt = await fetch('/products/montage.js').then(r => r.json());
    const ziel = findeMontageZiel(montageSummeInCent, montageProdukt.variants);
    if (!ziel) return;

    const passtSchon = montageItems.length === 1
      && montageItems[0].variant_id === ziel.variante.id
      && montageItems[0].quantity === ziel.menge;
    if (passtSchon) return;

    montageItems.forEach(i => { updates[i.key] = 0; });

    // Liegt die Ziel-Variante schon im Cart, deren Zeile direkt auf die Menge
    // setzen — sonst hätte updates denselben Posten als key→0 UND variant→Menge.
    const vorhandeneZeile = montageItems.find(i => i.variant_id === ziel.variante.id);
    if (vorhandeneZeile) {
      updates[vorhandeneZeile.key] = ziel.menge;
    } else {
      // variant_id in updates legt den Posten neu an (Line-Item-Properties wie
      // _is_montage entfallen dabei — Erkennung läuft überall über den Handle).
      updates[ziel.variante.id] = ziel.menge;
    }
  }

  const response = await fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      updates,
      sections: getCartSectionId(),
      sections_url: window.location.pathname,
    })
  });

  let data = await response.json();
  // update.js mit variant_id-Key legt die Montage-Zeile ohne Properties neu an
  // (siehe oben). Lieferart anschließend nachschreiben, sonst fehlt sie nach
  // jedem Variantenwechsel der Montage.
  data = await ensureMontageLieferart(data);
  dispatchMontageCartUpdate(data);
}

// Setzt auf jede Montage-Zeile idempotent zwei Properties, die sie noch nicht
// trägt: die versteckte `_lieferart` (für die Bestell-Logik/Mail) und den
// sichtbaren `Liefertermin`-Hinweis (rendert im Checkout/Order unter der Zeile).
// Per change.js über den Zeilen-Index, bewusst ohne sections + ohne cart:update-
// Dispatch, um Re-Render und einen weiteren Montage-Sync zu vermeiden. Weil die
// Montagezeile bei jedem Sync neu aufgebaut wird (variant_id-Swap verliert
// Properties), läuft das hier nach JEDEM Sync — so steht der Hinweis zuverlässig
// im Checkout, auch bei vor einer Theme-Aktualisierung angelegten Warenkörben.
async function ensureMontageLieferart(cart) {
  const items = cart.items;
  let latest = cart;
  for (let i = 0; i < items.length; i += 1) {
    const item = items[i];
    if (item.handle !== MONTAGE_HANDLE) continue;
    const props = item.properties || {};
    const hatLieferart = props._lieferart === MONTAGE_LIEFERART;
    const hatTermin = props[MONTAGE_LIEFERTERMIN_KEY] === MONTAGE_LIEFERTERMIN_TEXT;
    if (hatLieferart && hatTermin) continue;
    const neueProps = Object.assign({}, props, {
      _lieferart: MONTAGE_LIEFERART,
      [MONTAGE_LIEFERTERMIN_KEY]: MONTAGE_LIEFERTERMIN_TEXT,
    });
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: i + 1, quantity: item.quantity, properties: neueProps }),
    });
    latest = await res.json();
  }
  return latest;
}

async function montageHinzufuegen(event, btn) {
  event.preventDefault();

  const variantId = btn.dataset.variantId;
  const menge = parseInt(btn.dataset.quantity || '1', 10);
  btn.disabled = true;
  btn.textContent = '...';

  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: variantId,
      quantity: menge,
      properties: { _is_montage: true, _lieferart: MONTAGE_LIEFERART },
      sections: getCartSectionId(),
      sections_url: window.location.pathname,
    })
  });

  const data = await response.json();

  document.getElementById('cart-montage-upsell')?.remove();
  dispatchMontageCartUpdate(data);

  // Falls sich der Warenkorb seit dem Rendern der Upsell-Box geändert hat,
  // direkt auf die korrekte Variante/Menge nachziehen (No-op wenn alles passt).
  syncMontage();
}

// Für hali-liefertermin-sync.js: nach dem Nachschreiben von _montage_preis auf
// eine Bundle-Zeile den Abgleich erneut anstoßen (ohne Section-Re-Render dort).
window.syncMontage = syncMontage;

document.addEventListener('cart:update', (event) => {
  // Eigene Events nicht erneut verarbeiten — der Sync ist idempotent, aber
  // ohne Marker würde jeder Swap einen weiteren (überflüssigen) Lauf anstoßen.
  if (event.detail?.data?.source === 'cart-montage') return;
  syncMontage();
});
